<template>
  <v-dialog :value="open" max-width="800" @click:outside="close">
    <v-card>
      <v-card-title class="headline mb-2">
        Seleccionar Comprobantes Adicionales
      </v-card-title>
      
      <v-card-text>
        <!-- Combobox múltiple de comprobantes -->
        <v-combobox
          v-model="selectedVouchers"
          :items="vouchers"
          :loading="loading"
          item-text="voucher_number_label"
          item-value="id"
          label="Seleccionar comprobantes"
          multiple
          chips
          deletable-chips
          return-object
          hint="Últimos 10 comprobantes del cliente"
          persistent-hint
          :disabled="loading"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip
              v-if="index < 3"
              close
              color="primary"
              outlined
              @click:close="removeVoucher(item)"
            >
              {{ item.voucher_number_label }}
            </v-chip>
            <span
              v-if="index === 3"
              class="grey--text text-caption ml-2"
            >
              (+{{ selectedVouchers.length - 3 }} más)
            </span>
          </template>

          <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-bind="attrs" v-on="on">
              <v-list-item-action>
                <v-checkbox :input-value="attrs.inputValue"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.voucher_number_label }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ formatDate(item.cbte_fch) }} - {{ formatPrice(item.imp_total) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-slot:no-data>
            <div class="pa-4 text-center grey--text">
              No hay comprobantes disponibles para este cliente
            </div>
          </template>
        </v-combobox>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close">Cancelar</v-btn>
        <v-btn 
          color="success" 
          text
          @click="confirm"
          :disabled="selectedVouchers.length === 0"
        >
          Agregar 
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { vouchersService } from "@/libs/ws/vouchersService";
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  name: "DialogSelectVouchers",
  props: {
    open: Boolean,
    currentVoucherId: Number, // El comprobante actual para excluirlo
    clientId: Number, // ID del cliente para filtrar
    alreadySelected: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    loading: false,
    vouchers: [],
    selectedVouchers: [],
  }),
  watch: {
    open(val) {
      if (val) {
        this.loadVouchers();
        this.selectedVouchers = [];
      } else {
        this.vouchers = [];
        this.selectedVouchers = [];
      }
    },
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    
    confirm() {
      if (this.selectedVouchers.length > 10) {
        this.$toast.error("No puedes seleccionar más de 10 comprobantes", "Error");
        return;
      }
      this.$emit("vouchersSelected", this.selectedVouchers);
      this.close();
    },

    removeVoucher(voucher) {
      const index = this.selectedVouchers.findIndex(v => v.id === voucher.id);
      if (index > -1) {
        this.selectedVouchers.splice(index, 1);
      }
    },

    loadVouchers() {
      if (!this.clientId) {
        this.$toast.error("No se pudo obtener el cliente", "Error");
        return;
      }

      this.loading = true;
      const params = {
        client_id: this.clientId,
        limit: 10, // Solo últimos 10 comprobantes
      };

      vouchersService
        .getLastVouchersByClient(params)
        .then((response) => {
          if (response.status) {
            // Filtrar el comprobante actual y los ya seleccionados
            this.vouchers = response.result.filter((v) => {
              const isNotCurrent = v.id !== this.currentVoucherId;
              const isNotAlreadySelected = !this.alreadySelected.find(selected => selected.id === v.id);
              return isNotCurrent && isNotAlreadySelected;
            });
          } else {
            this.$toast.error(response.msg || "Error al cargar comprobantes", "Error");
          }
        })
        .catch((error) => {
          console.error("Error loading vouchers:", error);
          this.$toast.error("Error al cargar los comprobantes", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    formatDate(date) {
      return formatUtils.formatDateString(date);
    },

    formatPrice(price) {
      return formatUtils.formatPrice(price);
    },
  },
};
</script>
